import Keycloak from 'keycloak-js'
import store from '../../store'

const keycloakAuth = new Keycloak(`config/keycloak.json`)

export default (next, roles) => {
  keycloakAuth.init({onLoad: 'login-required', 'checkLoginIframe': false})
    .success((authenticated) => {
      if (!authenticated) {
        window.location.reload()
      }
      store.dispatch('authLogin', keycloakAuth)
    })
    .error(error => {
      console.log('failed to login', error)
    })
}



// WEBPACK FOOTER //
// ./src/front/actions/security/init.js